import { FC } from 'react';

import { ModifierCheckbox } from 'features/menu/components/product-detail/modifier/modifier-checkbox';
import { ModifierMultipleChoices } from 'features/menu/components/product-detail/modifier/modifier-multiple-choices';
import { ModifierNonNumeric } from 'features/menu/components/product-detail/modifier/modifier-non-numeric';
import { ModifierSingleChoice } from 'features/menu/components/product-detail/modifier/modifier-single-choice';
import {
  IModifierData,
  ModifierType,
} from 'features/menu/components/product-detail/modifier/types';
import { MultipliersSelections } from 'features/menu/components/product-wizard/types';

export interface IModifierProps extends IModifierData {
  onSelectionsChange: (selections: MultipliersSelections) => void;
}

export const Modifier: FC<IModifierProps> = props => {
  const { modifier } = props;

  switch (modifier.type) {
    case ModifierType.NON_NUMERIC:
      return <ModifierNonNumeric {...props} />;
    case ModifierType.CHECKBOX:
      return <ModifierCheckbox {...props} />;
    case ModifierType.NUMERIC:
      return null;
    case ModifierType.SINGLE_CHOICE:
      return <ModifierSingleChoice {...props} />;
    case ModifierType.MULTIPLE_CHOICE:
      return <ModifierMultipleChoices {...props} />;
    default:
      return null;
  }
};
